export const peopleQueryKeys = {
  _base: () => ["people"],
  all: (agencyId: string) => [...peopleQueryKeys._base(), { agencyId }],
  single: (personId: string) => [
    ...peopleQueryKeys._base(),
    "single",
    { personId },
  ],
  emails: (personId: string, date?: string) => [
    ...peopleQueryKeys.single(personId),
    "emails",
    { date },
  ],
};
